package com.example.readingnotes.platform

import kotlinx.browser.localStorage

/**
 * Web/JS implementation of KeyValueStorage using localStorage
 */
class KeyValueStorageJs : KeyValueStorage {
    override fun getString(key: String, defaultValue: String?): String? {
        val value = localStorage.getItem(key)
        return value ?: defaultValue
    }

    override fun setString(key: String, value: String?) {
        if (value == null) {
            localStorage.removeItem(key)
        } else {
            localStorage.setItem(key, value)
        }
    }

    override fun getInt(key: String, defaultValue: Int): Int {
        val value = localStorage.getItem(key)
        return value?.toIntOrNull() ?: defaultValue
    }

    override fun setInt(key: String, value: Int) {
        localStorage.setItem(key, value.toString())
    }

    override fun getBoolean(key: String, defaultValue: Boolean): Boolean {
        val value = localStorage.getItem(key)
        return value?.toBooleanStrictOrNull() ?: defaultValue
    }

    override fun setBoolean(key: String, value: Boolean) {
        localStorage.setItem(key, value.toString())
    }

    override fun remove(key: String) {
        localStorage.removeItem(key)
    }

    override fun clear() {
        localStorage.clear()
    }
}

/**
 * Factory function to create KeyValueStorage for JS platform
 */
actual fun createKeyValueStorage(): KeyValueStorage = KeyValueStorageJs()
